import React from 'react';
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";

const PropertiesListSkeleton = ({className}) => {
    return (
        <Property className={(className ?? '')}>
            <Figure>
                <Image>
                    <Skeleton height="100%" width="100%"/>
                </Image>

                <Figcaption className="pl-0 pl-md-24 pr-0 pr-md-16  d-block d-md-flex">
                    <div className="d-block d-md-flex flex-column w-100">
                        <Skeleton width="40%"/>
                        <Skeleton width="70%"/>
                        <Skeleton width="100%"/>
                    </div>

                    <div className="mt-8 mt-md-auto d-flex align-items-end justify-content-between">
                        <PriceContainer className="d-flex flex-column d-md-block">
                            <Skeleton width={100}/>
                            <Skeleton width={110}/>
                        </PriceContainer>
                        <div className="d-block d-md-none">
                            <Skeleton width={110} height={27}/>
                        </div>
                    </div>
                </Figcaption>

                <Contact className="d-none d-lg-flex flex-column">
                    <div className="d-flex mt-8">
                        <Skeleton width={72} height={72} circle={true}/>

                        <div className="mr-16 d-flex flex-1 justify-content-center flex-column">
                            <Skeleton width={88}/>
                            <Skeleton width={'100%'}/>
                        </div>
                    </div>

                    <div className="mt-auto">
                        <Skeleton width="100%" height={36}/>
                    </div>
                </Contact>
            </Figure>
        </Property>
    );
};

export default PropertiesListSkeleton;

// styles

const Property = styled.div`
    position: relative;
    padding: 24px 0;
    transition: all .2s ease-in-out;
    border-bottom: 1px solid ${props => props.theme.gray200};
`;

const Image = styled.div`
    height:185px;
    width:260px;
    position: relative;
    top: -8px;
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        width: 100%;
        height: 54vw;
        top: 0;
    }
`;

const Figure = styled.figure`
    display: flex;
    @media (max-width: ${props => props.theme.screenXsMax}) {
        display: block;
    }
`;

const Figcaption = styled.figcaption`
    width: calc(100% - 520px);
    position: relative;
    top: -8px;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        width: calc(100% - 260px);    
    }
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        width: 100%;   
        margin-top: 12px; 
        top: 0;
    }
`;

export const PriceContainer = styled.div`
    margin-top: auto;
    text-align: left;
    line-height: 1.5;
    margin-bottom: -10px;

    @media (max-width: ${props => props.theme.screenXsMax}) {
        position: relative;
        text-align: right;
        margin-bottom: 0;
    }
`;

const Contact = styled.div`
    width: 260px;
    padding: 24px 24px 0 0;
    border-right: 1px solid ${props => props.theme.gray200};
    margin-bottom: 2px;
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        margin-bottom: 0;
    }
`;